import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const LoginChoice = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-white to-blue-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8" data-testid="login-choice-page">
      <div className="sm:mx-auto sm:w-full sm:max-w-2xl px-4">
        <div className="flex justify-center mb-6">
          <img src="/logo.png" alt="Ment-Ally Logo" className="h-20 w-20" />
        </div>
        <h1 className="text-center text-4xl font-bold text-gray-900 mb-3">
          Welcome to Ment-Ally
        </h1>
        <p className="text-center text-lg text-gray-600 mb-12">
          Choose how you'd like to continue
        </p>

        <div className="grid md:grid-cols-2 gap-6">
          {/* People (Help-seekers) */}
          <button
            onClick={() => navigate('/login/people')}
            className="card group hover:shadow-2xl transition-all p-8 text-left bg-white border-2 border-transparent hover:border-teal-500"
            data-testid="login-people-button"
          >
            <div className="flex items-center justify-center w-16 h-16 rounded-full bg-teal-100 mb-6 mx-auto group-hover:bg-teal-200 transition-colors">
              <span className="text-4xl">🤝</span>
            </div>
            <h2 className="text-2xl font-bold text-center mb-3 text-gray-900 group-hover:text-teal-600 transition-colors">
              I'm looking for support
            </h2>
            <p className="text-center text-gray-600 leading-relaxed mb-4">
              Find mental health services, helplines, and support near you. Browse anonymously or create an account to save favorites.
            </p>
            <div className="text-center">
              <span className="text-teal-600 font-semibold group-hover:underline">
                Continue as People →
              </span>
            </div>
          </button>

          {/* Provider */}
          <button
            onClick={() => navigate('/login/provider')}
            className="card group hover:shadow-2xl transition-all p-8 text-left bg-white border-2 border-transparent hover:border-blue-500"
            data-testid="login-provider-button"
          >
            <div className="flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 mb-6 mx-auto group-hover:bg-blue-200 transition-colors">
              <span className="text-4xl">🏥</span>
            </div>
            <h2 className="text-2xl font-bold text-center mb-3 text-gray-900 group-hover:text-blue-600 transition-colors">
              I offer mental health services
            </h2>
            <p className="text-center text-gray-600 leading-relaxed mb-4">
              Register your organization, manage service listings, and help people find the support you provide.
            </p>
            <div className="text-center">
              <span className="text-blue-600 font-semibold group-hover:underline">
                Continue as Provider →
              </span>
            </div>
          </button>
        </div>

        <div className="mt-8 text-center">
          <button
            onClick={() => navigate('/')}
            className="text-gray-600 hover:text-teal-600 font-medium"
          >
            ← Back to home
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginChoice;
